(function AgentAttachmentsUploadedAttachments($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		// createAttachmentLink
		Adzuki.onload('/AgentAttachments/uploadedAttachments', function onload()
		{
			$('.attachment-url-copy').click(function doUrlCopy(e) {
				var attachment_id = $(this).data('attachment-id');

				e.preventDefault();

				Adzuki.Ajax.get('/AgentAttachments/createAttachmentLink/' + attachment_id)
				.then(function _receiveContent(content) {
					copyToClipboard(content.url);
				});
			});
		}, false);
	});

	function copyToClipboard(url)
	{
		const textArea          = document.createElement("textarea");
		textArea.style.position = "fixed";

		textArea.value = url;
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			document.execCommand('copy');
		} catch (err) {
			console.error('Unable to copy to clipboard', err);
			Adzuki.StatusMessage('Error', 'Error copying attachment link to clipboard.');
			return;
		}

		document.body.removeChild(textArea);

		Adzuki.StatusMessage('Success', 'Your attachment link has been copied to your clipboard.');
	}
	// custom functions
}(jQuery, window.Adzuki || {}));